'use client'

import { CommandPalette } from '@/components/command-palette'
import { useCommandPaletteContext } from '@/lib/command-palette-context'

export function CommandPaletteWrapper() {
  const { open, setOpen } = useCommandPaletteContext()
  
  return <CommandPalette open={open} onOpenChange={setOpen} />
}
